import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaskModule } from 'ngx-mask';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

const materialModules = [
	MatButtonModule,
	MatInputModule,
	MatListModule,
	MatIconModule,
	MatTooltipModule,
	MatDatepickerModule,
	MatNativeDateModule,
	NgxMaskModule.forRoot(),
	MatButtonToggleModule,
	MatFormFieldModule,
	MatSlideToggleModule,
	MatProgressBarModule
];

@NgModule({
	declarations: [],
	imports: [materialModules],
	exports: [materialModules]
})
export class MaterialModule {}
